import React, { useState, useEffect, useContext } from 'react';
import {format, getHours, subDays} from "date-fns";

import * as net from "../../lib/net";
import * as utils from "../../assets/utils";

import Td_Sel from "../../lib/ui/td_sel";
import Dt_Cal from "../../lib/ui/dt_cal";

import Lev_Fakt_Add from "./fkn/lev_fakt_add";
import Lev_Fakt_Edit from "./fkn/lev_fakt_edit";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Wrk_Tax extends React.Component {
  constructor(props, context) {
    super(props);

      this.dt_fd = React.createRef();
      this.dt_td = React.createRef();

    this.store = props.store;
    this.bcs = props.store.bcs;
    this.state = {};
    this.state.avd = "01";

    this.state.fka = [];
      this.state.tot = {};
      this.state.kfo = {};
      this.state.lfo = {};
      this.state.txo = {};

    this.state.tro = {};
    this.state.wnds = {};
      this.state.typ = "";
      this.state.sortid = "";
      this.state.sortdir = 1;

    this.state.today = new Date();
    var datum = format(this.state.today, "yyyy-MM-dd");
    this.state.fdat = datum.substr(0, 8) + "01";
    this.state.tdat = datum;

    this.selitems = [
        {fkn: 'open', text: 'ÖPPNA'},
        {fkn: 'status', text: 'STATUS'},
        {fkn: 'remove', text: 'TA BORT'}
    ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.tax_per();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 265;
      css.overflow = "auto";
      return css;
  }
  tab_style(typ) {
      var css = {};
      if(this.state.typ == typ) { css.background = "#009900"; css.color = "#fff"; }
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
  th_style(id) {
      var css = {};
      css.cursor = "pointer";
      if(id == this.state.sortid) css.color = "#080";
      return css;
  }
    dt_fdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ fdat: dts });
    }
    dt_tdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ tdat: dts });
    }
    oneday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_td.current.updateDt(this.state.fdat);
    }
    addday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateAdd();
        this.dt_td.current.updateAdd();
    }
    subday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateSub();
        this.dt_td.current.updateSub();
    }

    lev_fak_add() {
        var self = this;
        var wnds = {};
        wnds.levfaktadd = true;
        wnds.cb = self.cb_fkn;
        this.setState({ wnds: wnds });
    }
  lev_fak_edit(row) {
    var self = this;
    var wnds = {};
    wnds.levfaktedit = true;
    wnds.fko = row;
    wnds.cb = self.cb_fkn;
    this.setState({ wnds: wnds });
  }
    cb_fkn(ctx) {
        ctx.setState({ wnds: {} });
        ctx.fak_per();
    }
    task_fkn() {
    }

    tax_per() {
    var self = this;
    self.setState({ fka: [] });

    var prm = {};
    prm.req = "bfs.tax.tax_per";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ kfo: ret.kfo, lfo: ret.lfo, txo: ret.txo });
        //self.syncTb("fkaTable");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
   tb_sort(typ) {
      var self = this;
      //var rvs = self.state.rvs;
      var tsa = self.state.tsa;
      var sz = this.state.sz_val;

      tsa.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
      self.setState({ tsa: tsa, sortid: typ });
   }
  sel_row_fkn(row, sel) {
      //alert(JSON.stringify(fkn));
    if(sel.fkn == "open") {
        //this.sel_gst(row);
    }
    if(sel.fkn == "br") {
    }
  }
   refresh() {
      this.fak_per();
    }
    stat_txt(status) {
        var text = "";
        status = status.toString().tonum(1);
        if( status == '0' )  text = 'REGISTRERAD';
        if( status == '1' )  text = 'BEARBETAS';
        if( status == '3' )  text = 'VÄNTAR';
        if( status == '5' )  text = 'KLAR';
        if( status == '7' )  text = 'FAKTURERAD';
        if( status == '9' )  text = 'AVSLUTAD';
        return text;
    }
    pr_txt(pid) {
        var text = "";
        pid = pid.toString().tonum(5);
        if( pid == '00000' )  text = 'EJ TILLDELAD';
        if( pid == '00001' )  text = 'Joakim';
        if( pid == '00002' )  text = 'Daniel';
        if( pid == '00003' )  text = 'Stellan';
        if( pid == '00004' )  text = 'Tobias';
        if( pid == '00005' )  text = 'Emmanuel';
        if( pid == '00006' )  text = 'Kari';
        return text;
    }
    kk_txt(kid) {
        var text = kid.ztrim();
        kid = kid.toString().tonum(10);
        var key = "K" + kid;
        if(this.bcs && this.bcs.kro && this.bcs.kro[key]) {
            text = text + " - " + this.bcs.kro[key].kk00.ftg;
        }
        return text;
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var fka = self.state.fka;
        var sz = this.state.sz_val;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(sortdir) fka.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
        else fka.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        self.setState({ fka: fka, sortid: typ, sortdir: sortdir });
    }

  render() {
    return (
    <div className="web-app">
    <div className="flex-row flex-space-between">
        <div className="flex-row">
            <div className="flex-row">
                <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
                <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
                <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
                <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
        </div>

        <div className="flex"></div>

        <div className="flex-row">
            <button className="btn btn-hw-orange w200" onClick={() => this.lev_fak_add() } aria-label="System" >
                MOMS DEKLARATION
            </button>
            <button className="btn btn-hw-blue w200" onClick={() => this.refresh() } aria-label="System" >
                UPPDATERA
            </button>
        </div>
    </div>
    <div className="divider_orange"></div>

        <div className="flex-row px-3">
            <div className="flex-col flex">
                <div className="txt_18 px-3">KUND:</div>
                <div className="divider_orange"></div>
                <div className="flex-row px-3"><div className="txt_14 w100">ANTAL:</div><div className="txt_18">{ utils.toNum(this.state.kfo.antal ) }</div></div>
                <div className="flex-row px-3"><div className="txt_14 w100">SUMMA:</div><div className="txt_18">{ utils.toPris(this.state.kfo.belopp ) }</div></div>
                <div className="flex-row px-3"><div className="txt_14 w100">MOMS:</div><div className="txt_18">{ utils.toPris(this.state.kfo.moms ) }</div></div>
            </div>

            <div className="flex-col flex">
                <div className="txt_18 px-3">MOMS DEKLARATION:</div>
                <div className="divider_orange"></div>
                <div className="flex-row px-3"><div className="txt_14 w150">MOMS:</div><div className="txt_18">{ utils.toPris(this.state.txo.moms ) }</div></div>
                <div className="flex-row px-3"><div className="txt_14 w150">ARBETSGIVARE:</div><div className="txt_18">{ utils.toPris(this.state.txo.agivare ) }</div></div>
                <div className="flex-row px-3"><div className="txt_14 w150">SKATT:</div><div className="txt_18">{ utils.toPris(this.state.txo.skatt ) }</div></div>
                <div className="flex-row px-3"><div className="txt_14 w150">ATT BETALA:</div><div className="txt_18">{ utils.toPris(this.state.txo.attbetala ) }</div></div>
            </div>

            <div className="flex-col flex">
                <div className="txt_18 px-3">LEVERANTÖR:</div>
                <div className="divider_orange"></div>
                <div className="flex-row px-3"><div className="txt_14 w100">ANTAL:</div><div className="txt_18">{ utils.toNum(this.state.lfo.antal ) }</div></div>
                <div className="flex-row px-3"><div className="txt_14 w100">SUMMA:</div><div className="txt_18">{ utils.toPris(this.state.lfo.belopp ) }</div></div>
                <div className="flex-row px-3"><div className="txt_14 w100">MOMS:</div><div className="txt_18">{ utils.toPris(this.state.lfo.moms ) }</div></div>
            </div>
        </div>

        { this.state.wnds.levfaktadd ? <Lev_Fakt_Add wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.levfaktedit ? <Lev_Fakt_Edit wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }

   </div>
  );
    }
}
export default Wrk_Tax;
